/**
 * 详情
 *
 * */
import React from 'react'
import {Modal,Form, } from "antd";
import Lang from "@components/Lang/Lang";
import Locale from "../../../../utils/locale";
import {toFixedWithCommas} from "../../../../utils/number-util";
import {splitNumberRu,toFixed2} from "@utils/utils";
import dayjs from "dayjs";
import "./index.less";
const locale = Locale.current();
const FormItem = Form.Item;
class Detail extends React.Component{
    static defaultProps = {
        model: {},
    };
    constructor(props) {
        super(props);
        this.state = {
            isVisible:false,
        }
    }
    /**
     * 打开弹窗
     */
    showModal=()=>{
        this.setState({
            isVisible:true
        });
    }

    onCancel=()=>{
        this.setState({
            isVisible:false
        });
    }

    render(){
        const {isVisible,loading,} = this.state;
        const { model} = this.props;
        let layout = {
            labelCol: { span: 7 },
            wrapperCol: { span: 17 },
            labelAlign:"left"
        };
        if(locale!="zh"){
            layout = {
                labelCol: { span: 10 },
                wrapperCol: { span: 14 },
                labelAlign:"left"
            };
        }
        return (
            <div className="payment-check-out-detail-wrap">
                <span onClick={this.showModal}>{this.props.children}</span>
                <Modal width="597px" centered={true} onCancel={this.onCancel} footer={false} title={Lang({id: "XiangQing", default: "详情"})} open={isVisible}>
                    <div className={"pop-payment-check-out-detail"}>
                        <Form
                            ref={this.formRef}
                            {...layout}
                            name="basic"
                            colon={false}
                        >
                            <FormItem
                                label={Lang({id: 'DanJuHao', default: '单据号'})}
                            >
                                {model.code||'-'}
                            </FormItem>
                            <FormItem
                                label={Lang({id: 'KeHu', default: '客户'})}
                            >
                                {model.buyerCode||'-'}<span className={"ml_6 con2-txt"}>{model.buyerName||'-'}</span>
                            </FormItem>

                            <FormItem
                                label={Lang({id: 'TuiKuanFangShi', default: '退款方式'})}
                            >
                                {model.payType?__getServerDictItem(`fin_remittance_item_pay_type.${model.payType}`):"-"}
                            </FormItem>

                            <FormItem
                                label={Lang({id: 'HuiKuanRiQi', default: '汇款日期'})}
                            >
                                {model.moneyOutTime
                                    ? dayjs(model.moneyOutTime).format("YYYY-MM-DD")
                                    : "-"}
                            </FormItem>

                            <FormItem
                                label={Lang({id: 'KouJianJinE', default: '扣减金额'})}
                            >
                                {locale=='ru'?<span>
                                   {model.moneyOut?splitNumberRu(toFixed2(model.moneyOut,2)):'-'} {model.currencySymbol}
                                </span>:<span>
                                    {model.currencySymbol}{model.moneyOut?toFixedWithCommas(model.moneyOut,2):'-'}
                                </span>}

                            </FormItem>

                            <FormItem
                                label={__getServerLanguage('YinHangLiuShuiHao')}
                            >
                                {model.bankSeq||'-'}
                            </FormItem>

                            <FormItem
                                label={__getServerLanguage('BeiZhu')}
                            >
                                {model.remark||'-'}
                            </FormItem>

                            <FormItem
                                label={__getServerLanguage('DengJiRen')}
                            >
                                {model.createBy||'-'}<span className={"ml_6 con2-txt"}>{model.createTime?dayjs(model.createTime).format('YYYY-MM-DD HH:mm'):'-'}</span>
                            </FormItem>
                        </Form>
                    </div>
                </Modal>
            </div>
        )
    }
}
export default Detail;
